module.exports = __webpack_public_path__ + "media/images/lb/564-5f0e4565eb871cbcffb95b5971ec2b9b.svg";